import { createErrorMessage, invitationLink } from '@avrahami/ui';
import { he } from '../i18n/he';

/** A Hebrew message for any error the UI shows. */
export const errorMessage = createErrorMessage(he);

/**
 * Where store owners set their password: the tenant admin (`VITE_TENANT_ADMIN_URL`, its origin)
 * when it is configured, otherwise this app's own origin.
 */
export function ownerInvitationOrigin(configured: string | undefined, fallback: string): string {
  const value = configured?.trim() ?? '';
  return value === '' ? fallback : value;
}

/** The tenant admin's origin, as this build knows it. */
function tenantAdminOrigin(): string {
  return ownerInvitationOrigin(import.meta.env.VITE_TENANT_ADMIN_URL, window.location.origin);
}

/** The invitation link of a store owner (it opens the tenant admin). */
export function ownerInvitationLink(token: string): string {
  return invitationLink(tenantAdminOrigin(), token);
}

/** Where a member of the platform staff enters a store's own admin (adr/0031). */
export function storeEntryLink(token: string): string {
  return `${tenantAdminOrigin().replace(/\/+$/, '')}/enter#${token}`;
}
